import React from 'react';

/**
 * MetricFlagTag (Lane 121) — a small inline "this figure is real but needs
 * context" marker for DISPLAY-HONESTY flags. It renders a dagger + a hover
 * tooltip ONLY when `show` is true, so a row that does not trip the condition is
 * pixel-identical to today (the markers are ungated but purely conditional).
 *
 * Used for:
 *  - impact% beyond +/-100% OR |impact| larger than a year's spend (the
 *    counterfactual / possible unit-of-measure / pack-size case, Lane 121 items 4+6);
 *  - a below-threshold coverage figure (Lane 121 item 5).
 *
 * Deliberately DISTINCT from AnomalyExclusionTag: that marker means "an order was
 * excluded from this figure by the bad-order guard"; this one means "the number
 * is real, here is how to read it". Same visual language (an orange dagger) as
 * the sibling markers already in these cells; the tooltip carries the meaning.
 * No math, no number change — a display affordance only.
 *
 * Linear rebuild Stage 2 (Lane 219, cross-page chrome): renders only inside the
 * Analytics `.an` Linear scope, so the dagger reads `var(--warn)` (was Meridian
 * `colors.warning`) — kept in lockstep with its twin AnomalyExclusionTag so the
 * two identical daggers in the same table cells share one amber.
 */
function MetricFlagTag({ show, title }) {
  if (!show || !title) return null;
  return (
    <span title={title} style={{ marginLeft: '4px', color: 'var(--warn)', cursor: 'help' }}>
      {'†'}
    </span>
  );
}

export default MetricFlagTag;
